<template>
  <div class="main-header" :class="{'no-zindex': registerModal}">
    <router-link to="/" class="logo">
      <img class="hidden-xs-only" src="/static/logo.svg">
      <img class="hidden-sm-and-up" src="/static/logo_mobile.svg">
    </router-link>
    <el-menu v-if="!$store.state.loggedIn"
             :router=true
             :default-active="activeIndex"
             class="el-menu-demo hidden-xs-only"
             mode="horizontal"
             menu-trigger="hover"
             @select="handleSelect">
      <router-link class="el-menu-item" to="/" :class="{'is-active' : ['home'].indexOf($route.name) !== -1 }">Showcase</router-link>
    </el-menu>
    <el-menu v-if="$store.state.loggedIn"
             :router=true
             :default-active="activeIndex"
             class="el-menu-demo hidden-xs-only"
             mode="horizontal"
             menu-trigger="hover"
             @select="handleSelect">
      <router-link class="el-menu-item" to="/" :class="{'is-active' : ['home'].indexOf($route.name) !== -1 }">Showcase</router-link>
      <router-link class="el-menu-item" to="/my-library" :class="{'is-active' : ['myLibrary'].indexOf($route.name) !== -1 }">
        My Library
      </router-link>
      <router-link class="el-menu-item" to="/palette-editor" :class="{'is-active' : ['paletteEditor'].indexOf($route.name) !== -1 }">
        Palette Editor
      </router-link>
    </el-menu>
    <div class="user-area" v-if="$store.state.loggedIn">
      <div class="reg-hold">
        <a class="el-button el-button--success el-button--medium" :href="$store.state.API_URL + 'edit/new'">Create new tour</a>
      </div>
      <div class="avatar-cnt custom-menu">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" menu-trigger="hover"
                 @select="handleSelect">
          <el-submenu index="3">
            <template slot="title"><span class="username hidden-xs-only">{{$store.state.user.username}}</span><img
                    src="/static/nouser.png"
                    alt="" class="avatar"></template>
            <el-menu-item index="3-3" class="hidden-sm-and-up pointer-none" style="color: black"><span class="username">{{$store.state.user.username}}</span></el-menu-item>
            <el-menu-item index="3-4" @click="logOut">Log out</el-menu-item>
          </el-submenu>
        </el-menu>

      </div>
    </div>
    <div class="reg-hold" v-if="!$store.state.loggedIn">
      <router-link to="/login" class="el-button el-button--primary el-button--medium" v-if="$route.name !== 'login'">LOG IN</router-link>
    </div>
    <div class="mobile-menu-btn hidden-sm-and-up" @click="$store.commit('setState', {mobileMenuActive: true})" >
      <div class="hamburger">
      </div>
    </div>
  </div>

</template>

<script>

  export default {
    name: 'App',
    data() {
      return {
        activeIndex: '1',
        activeIndex2: '1',
//        loggedIn: false,
        registerModal: false
      }
    },
    methods: {
      handleSelect(key, keyPath) {
//        console.log(key, keyPath);
      },
      register(role) {
        this.$router.push(role);
        this.registerModal = false
      },
      logOut() {
        this.$store.dispatch('authLogOut').then(() => {
          this.$router.push('/login')
        })
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/main-header.vue